<script lang="ts">
    // Job type colors matching PHP JobType enum
    const legendItems = [
        { label: 'Erect', color: 'green' },
        { label: 'Full Strike', color: 'rose' },
        { label: 'Extension', color: 'lime' },
        { label: 'Inspection', color: 'indigo' },
        { label: 'Maintenance', color: 'orange' },
        { label: 'Site Visit', color: 'blue' },
    ];
</script>

<div class="legend-container">
    {#each legendItems as item (item.label)}
        <div class="legend-item">
            <div
                class="legend-color"
                style:background-color={`var(--event-${item.color}-scheduler)`}
            ></div>
            <span class="legend-label">{item.label}</span>
        </div>
    {/each}
</div>

<style lang="scss">
    .legend-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.75rem 1rem;
        padding: 0.5rem 0.75rem;
        background: transparent;
        border-radius: 0.375rem;
    }

    .legend-item {
        display: flex;
        align-items: center;
        gap: 0.375rem;
    }

    .legend-color {
        width: 0.75rem;
        height: 0.75rem;
        border-radius: 0.25rem;
        border: 1px solid rgba(0, 0, 0, 0.2);
    }

    .legend-label {
        font-size: 0.75rem;
        color: var(--muted-foreground);
        white-space: nowrap;
    }
</style>